import React, { useContext, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import StandardDropdown from '../../../Dropdown/Preset/StandardDropdown';
import s from './ThreadHeader.scss';
var ThreadHeader = function (_a) {
    var total = _a.total, _b = _a.withOrder, withOrder = _b === void 0 ? true : _b, _c = _a.withTitle, withTitle = _c === void 0 ? true : _c, children = _a.children, order = _a.order, className = _a.className, onOrderChanged = _a.onOrderChanged, streamId = _a.streamId;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var items = useMemo(function () { return [
        {
            label: t('commentthread.control.newest'),
            value: 'newest',
        },
        {
            label: t('commentthread.control.oldest'),
            value: 'oldest',
        },
    ]; }, [t]);
    var handleOrderChanged = useCallback(function (value) {
        onOrderChanged && onOrderChanged(streamId, value);
    }, [onOrderChanged, streamId]);
    if (!withOrder && !withTitle) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { className: className, alignItems: "center", dataHook: BiDataHook.COMMENTS_THREAD_STATS },
            React.createElement("div", { "data-hook": BiDataHook.COMMENTS_THREAD_COUNT }, withTitle && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: s['title'] }, t('commentthread.control.comments')),
                total !== undefined && (React.createElement("span", { className: s['total'] }, total))))),
            !isMobile && React.createElement(React.Fragment, null, children),
            withOrder && isLoggedIn && (React.createElement("div", { className: s['order-select'], "data-hook": BiDataHook.COMMENTS_THREAD_SORTING },
                React.createElement(StandardDropdown, { role: "menu", placement: isMobile ? 'bottom-end' : 'bottom-start', toggleClassName: s['order-select-toggle'], arrowClassName: s['order-select-arrow'], selectedValue: order, items: items, onSelect: handleOrderChanged })))),
        isMobile && React.createElement(Flex, null, children)));
};
ThreadHeader.displayName = 'ThreadHeader';
export default ThreadHeader;
//# sourceMappingURL=ThreadHeader.js.map